import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import * as services from "../api/services"
import { ADMIN_DEFLECT_ANALYTICS_SLICE_NAME as SLICE_NAME } from "./adminDeflectAnalytics.constants"

// Every card's thunk takes the card's query params. A failed request raises the platform's global
// error notification and the card keeps its data (DAA-1-17); one cancelled by a newer filter change
// fails silently.
const cardThunk = (type, request) =>
  createAsyncThunk(
    `${SLICE_NAME}/${type}`,
    async (params, { dispatch, rejectWithValue, signal }) => {
      const response = await request(params, signal)

      if (!response.ok) {
        if (!signal.aborted) await handleApiError(dispatch, response)
        return rejectWithValue(response.data)
      }

      return response.data
    }
  )

// Each card's thunk by the store key of its response.
export const CARD_THUNKS = {
  lookupsOverview: cardThunk("get_lookups_overview", services.getLookupsOverview),
  lookupVolume: cardThunk("get_lookup_volume", services.getLookupVolume),
  activeMerchants: cardThunk("get_active_merchants", services.getActiveMerchants),
  unbillableChannels: cardThunk("get_unbillable_channels", services.getUnbillableChannels),
  unbillableNewValues: cardThunk("get_unbillable_new_values", services.getUnbillableNewValues),
  unbillableAllValues: cardThunk("get_unbillable_all_values", services.getUnbillableAllValues),
  matchRate: cardThunk("get_match_rate", services.getMatchRate),
  worstMerchants: cardThunk("get_worst_merchants", services.getWorstMerchants),
  revenue: cardThunk("get_revenue", services.getRevenue),
  averageValue: cardThunk("get_average_value", services.getAverageValue),
  recordsByStatus: cardThunk("get_records_by_status", services.getRecordsByStatus),
  timeToActive: cardThunk("get_time_to_active", services.getTimeToActive)
}
